import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

import { defaultTextValues, textSchema } from '../../Text/model/TextSchema';

export const chapterBookAuthorSchema = z.object({
  authorName: z.string().min(3),
  membership: identitySchema,
});

export const chapterSchema = textSchema.extend({
  type: identitySchema.nullable(),
  bookName: z.string().nullable(),
  bookSeries: z.string().nullable(),
  bookAuthors: z.array(chapterBookAuthorSchema),
  bookIsbn: z
    .object({
      printCode: z.string().nullable(),
      onlineCode: z.string().nullable(),
    })
    .nullable(),
  authors: z.array(authorSchema).min(1),
});

export const defaultChapterValues: DefaultValues<ChapterSchema> = {
  authors: [],
  bookAuthors: [],
  bookName: '',
  bookSeries: '',
  type: null,
  bookIsbn: {
    printCode: '',
    onlineCode: '',
  },
  ...defaultTextValues,
};

export type ChapterSchema = z.infer<typeof chapterSchema>;
export type ChapterBookAuthorSchema = z.infer<typeof chapterBookAuthorSchema>;
